import * as React from "react";
import { Button, Grid } from "@mui/material";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import { makePostRequest,
  // makeGetRequest,
  uploadFileRequest, } from "../../../utils/utils";
import swal from "sweetalert";
  
import Switch from "@mui/material/Switch";
import FileUploadIcon from "@mui/icons-material/FileUpload";
// import { useNavigate } from "react-router-dom";

const label = { inputProps: { "aria-label": "Size switch demo" } };

const Validation_Schema = Yup.object().shape({
  amenityName: Yup.string().required("Required"),
  // status: Yup.string().required("Required"),
  is_paid: Yup.string(),
  charges: Yup.string().matches(/^\d+$/, "The field should have digits only"),
  duration: Yup.string()
    .required("Required"),
  capacity: Yup.string()
    .matches(/^\d+$/, "The field should have digits only")
    .required("Required"),
 
});



function AmenitiesModal() {
  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };

  const[amenityName,setAmenityName]=React.useState('');
  const[is_paid,setIsPaid]=React.useState();
  const[is_active,setIsActive]=React.useState(true);
  const[duration,setDuration]=React.useState();
  const[charges,setCharges]=React.useState();
  const[capacity,setCapacity]=React.useState();
  const[lstAmenityPics,setLstAmenityPics]=React.useState([]);

  // const [value, setValue] = React.useState(0);
  // const navigate = useNavigate();

  // const handleChange = (event, newValue) => { 
  //   setValue(newValue);
  // };

  const handleChangeDuration = (event) => { 
    // alert(event.target.value);
    if(event.target.value!=='Duration')
    { 
      setDuration(event.target.value);
    }
  };

  const handleChangeIsPaid=(event)=>{
    // alert(event.target.value);
    if(event.target.value!=='Free/Paid')
      setIsPaid(event.target.value)
    // else
    //   setIsPaid('Free')
  }

  const handleChangeStatus=(event)=>{
    setIsActive(event.target.checked);
  }


  var formikInitials={
    amenity_name:'',
    is_paid:false,
    status:true,
    capacity:'',
    access_time:'',
    charges:''
  }
  
  async function addAmenity() {
    let paidVal='';
    if(is_paid==='Paid')
      paidVal='true'
    else
    paidVal='false'
  let inputdata = {
    amenity_name: amenityName,
    is_paid: paidVal,
    status: is_active,
    capacity: capacity,
    access_time: duration,
    charges: charges,
    society_id:localStorage.getItem('socityid'),
    lstAmenityImages
    :lstAmenityPics
  };
  
  makePostRequest("amenities/insert", inputdata)
  .then((response) => {
    if (response.data.status === "1") {
     
      swal("Success", "Amenity added successfully", "success", {
        timer: 1000,
        buttons: false,
      });
      window.location.reload();
    } 
  })
  .catch((err) => {
    swal("There was an error!", "more error details", "warning");
    console.log("Something went wrong!!", err);
  });
  }

  
  
  
  async function uploadImageOrFile(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;

    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
        console.log(response.data.imagepath[0]);
      }
    );
    alert("File 2" + fileUrl);
    return fileUrl;
  }

  function validateImageOrFile(fileData) {
    if (fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
      return true;
    else return false;
  }

  async function uploadAmenityImages(e) {
    // handle validations
    const file = e.target.files[0];
    var imageUrl = await uploadImageOrFile(file);
   
      lstAmenityPics.push(imageUrl);
      setLstAmenityPics(lstAmenityPics);
  }


  return (
    <>
      <div id="successfullAdd">
        <Formik enableReinitialize
                initialValues={formikInitials}
                validationSchema={Validation_Schema}
                onSubmit={addAmenity} >
        {({
                values,
                handleChange,
                errors,
                setFieldTouched,
                touched,
                isValid,
                handleSubmit,
              }) => (
                <Form>
        <Grid container spacing={3} className="addCommitee1">
          <Grid item xs={12} md={6}>
            <input
              className="inputSt"
              type="text"
              placeholder="Enter Amenity Name"
              value={values.amenityName}
              onChange={handleChange("amenityName")}
              onBlur={() => setFieldTouched("amenityName")}
              onChangeCapture={(e) =>
                setAmenityName(e.target.value)
              }
            />
            {errors.amenityName && touched.amenityName ? (
              <div
                style={{ color: "red" }}
                className="errorField"
              >
                {errors.amenityName}
              </div>
            ) : null}
          </Grid>
          <Grid item xs={12} md={6}>
            <select className="inputSt" 
              value={is_paid}
              onChange={(event)=>handleChangeIsPaid(event) }>
              <option>Free/Paid</option>
              <option value={'Free'}>Free</option>
              <option value={'Paid'}>Paid</option>
            </select>
          </Grid>
          <Grid item xs={12} md={6}>
            <select className="inputSt" value={values.duration}
              onChange={(event)=>handleChangeDuration(event) }>
              <option>Duration</option>
              <option value={'Hourly'}>Hourly</option>
              <option value={'Half Day'}>Half Day</option>
              <option value={'Full Day'}>Full Day</option>
            </select>
          </Grid>
          <Grid item xs={12} md={6}>
            <input
              className="inputSt"
              type="text"
              placeholder="Enter Charges"
              value={values.charges}
              onChange={handleChange("charges")}
              onBlur={() => setFieldTouched("charges")}
              onChangeCapture={(e) =>
                setCharges(e.target.value)
              }
            />
            {errors.charges && touched.charges ? (
              <div
                style={{ color: "red" }}
                className="errorField"
              >
                {errors.charges}
              </div>
            ) : null}
          </Grid>
          <Grid item xs={12} md={6}>
            <input
              className="inputSt"
              type="text"
              placeholder="Enter Capacity"
              value={values.capacity}
                              onChange={handleChange("capacity")}
                              onBlur={() => setFieldTouched("capacity")}
                              onChangeCapture={(e) =>
                                setCapacity(e.target.value)
                              }
                            />
                            {errors.capacity && touched.capacity ? (
                              <div
                                style={{ color: "red" }}
                                className="errorField"
                              >
                                {errors.capacity}
                              </div>
                            ) : null}
          </Grid>
          <Grid item xs={12} md={6} className="switchMain">
            <Switch {...label} checked={is_active} size="small" 
             onChange={(event)=>handleChangeStatus(event)}           />
           
          </Grid>

          <Grid item xs={12} md={12}>
            <div className="upImDiv">
            {lstAmenityPics.map((option, index) => (
              <div className="uploadedImView">
                <img src={option} />
              </div>
            ))}
              <div className="forUploadBt">
                <FileUploadIcon />
                <input type="file" id="lstAmenityPics"
                              value={values.lstAmenityPics}
                              onChange={(event) =>
                                uploadAmenityImages(event)
                              }/>
              </div>
            </div>
          </Grid>

          <Grid item xs={12} md={12}>
            <div className="modalMainBtMain">
              <Button className="modalMainBt" onClick={addAmenity}>
                Add
              </Button>
            </div>
          </Grid>
        </Grid>
        </Form>
              )}
        </Formik>
        <Grid container spacing={3} className="addCommitee2">
          <Grid item xs={12} md={12}>
            <div className="succesMain">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
              <h4>Success !</h4>
              <p>Amenity added successfully</p>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
export default AmenitiesModal;
